import React from "react";
const IconGift = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" aria-hidden {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.999 7.812c.042-1.585-.904-4.761-3.245-4.811-1.782-.039-2.418 1.58-2.418 2.312 0 .733.445 2.5 2.704 2.5m2.959 0H7.04m2.959 0V17H4.125a1 1 0 0 1-.994-1.117l.847-7.188a1 1 0 0 1 .993-.883h2.07M10 17h5.874a1 1 0 0 0 .994-1.117l-.847-7.188a1 1 0 0 0-.993-.883h-2.07m0 0h-2.958c-.042-1.585.904-4.761 3.245-4.811 1.782-.039 2.418 1.58 2.418 2.312 0 .733-.445 2.5-2.704 2.5Z"
    />
  </svg>
);
export default IconGift;
